import { render } from "./ReconRealtime.vue?vue&type=template&id=b8a8dffa&scoped=true"
import script from "./ReconRealtime.vue?vue&type=script&lang=js"
export * from "./ReconRealtime.vue?vue&type=script&lang=js"

import "./ReconRealtime.vue?vue&type=style&index=0&id=b8a8dffa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8a8dffa"]])

export default __exports__